import React, { useEffect, useState } from 'react'
import { ChooseCatalog } from '../../components/catalogPage/chooseCatalog/ChooseCatalog'
import { BrandFilter } from '../../components/catalogPage/brandFilter/BrandFilter';
import { ArticleFilter } from '../../components/catalogPage/articleFilter/ArticleFilter';
import { useSearchParams } from 'react-router';

export function CatalogPage() {
    const [searchParams, setSearchParams] = useSearchParams({ catalog: "brand" });


    const handleChooseCatalog = (value) => {
        setSearchParams("")
        setSearchParams({ catalog: value });
    };

    return (
        < >
            <ChooseCatalog catalog={searchParams.get("catalog")} setCatalog={handleChooseCatalog} />
            {searchParams.get("catalog") === "brand" ? <BrandFilter /> : <ArticleFilter />}
        </ >
    )
}